import pluralize from './pluralize';

export default pluralize;
